import jQuery from "jquery"
import "vendor/js/plugins/bootstrap/bootstrap.bundle.min"
import "vendor/js/plugins/popperjs/popperjs.min"
import "bootstrap/js/dist/carousel"
import "countup.js"
import flatpickr from "flatpickr"
import autonumeric from "autonumeric"

// Init event for google maps
window.initMap = function (...args) {
  const event = document.createEvent("Events")
  event.initEvent("google-maps-callback", true, true)
  event.args = args
  window.dispatchEvent(event)
}

window.$ = window.jQuery = jQuery
window.autonumeric = autonumeric

// format money
window.formatMoney = function(price, currency) {
  return autonumeric.format(price, { currencySymbol: currency || '' })
}


// Handle issue accordion Bootstrap yang tidak bisa di-close
if (!window._patchedAccordion) {
  // Block handler collapse bawaan Bootstrap
  document.body.addEventListener("show.bs.collapse", function (e) {
    e.preventDefault(); // Cegah Bootstrap memaksa buka
  });

  document.body.addEventListener("hide.bs.collapse", function (e) {
    e.preventDefault(); // Cegah Bootstrap memaksa tutup
  });

  // Manual handler
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest('[data-bs-toggle="collapse"]');
    if (!btn) return;

    e.preventDefault();

    const selector = btn.getAttribute("data-bs-target") || btn.getAttribute("href");
    if (!selector) return;

    const target = document.querySelector(selector);
    if (!target) return;

    const isShown = target.classList.contains("show");

    // Matikan Bootstrap instance kalau ada
    const bs = bootstrap?.Collapse?.getInstance?.(target);
    if (bs) bs.dispose();

    // Tutup lainnya jika pakai data-bs-parent
    const parentSelector = target.getAttribute("data-bs-parent");
    if (parentSelector) {
      document.querySelectorAll(`${parentSelector} .accordion-collapse.show`).forEach((el) => {
        if (el !== target) {
          el.classList.remove("show");
          el.style.height = "0";
        }
      });
    }

    // Toggle
    target.classList.toggle("show", !isShown);
    target.style.height = !isShown ? "" : "0";
  });

  window._patchedAccordion = true;
}
